class NotificationPopup extends HTMLElement {
  connectedCallback() {
    this.popup = document.querySelector(".not-pu-section");
    this.overlay = document.querySelector('.notification-popup-overlay');
    this.discountButton = document.querySelector('.hs--overlay--discount-button');
    this.closeDiscountButton = document.querySelector('.hs--overlay--discount-button--inner--close');
    
    if (!this.popup) return;

    this.closeBtn = this.popup.querySelector(".newsletter__close-btn");
    this.hasSubscription = this.dataset.hasSubscription === "true";
    this.delay = Number(this.dataset.delay) || 0;
    this.cookie = document.cookie.includes("hideNotificationPopup=true");
    this.discountCookie = document.cookie.includes("hideDiscountButton=true");

    // Don't show popup if user is subscribed or cookie exists
    if (this.hasSubscription || this.cookie) {
      // Check if discount button should be shown
      if (!this.discountCookie) {
        this.showDiscountButton();
      } else {
        this.hideDiscountButton();
      }
      return;
    }

    // Initially hide discount button (will show after popup is closed)
    this.hideDiscountButton();

    // Show popup and overlay after delay
    setTimeout(() => {
      this.showPopup();
    }, this.delay * 1000);

    // Close popup when clicking close button
    if (this.closeBtn) {
      this.closeBtn.addEventListener("click", (e) => {
        e.preventDefault();
        this.closePopup();
      });
    }

    // Close when clicking overlay
    if (this.overlay) {
      this.overlay.addEventListener('click', () => {
        this.closePopup();
      });
    }

    // Close with Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.popup && !this.popup.classList.contains('hidden')) {
        this.closePopup();
      }
    });

    // Handle discount button click to show popup again
    if (this.discountButton) {
      this.discountButton.addEventListener('click', (e) => {
        // Check if clicked on close button inside discount button
        if (this.closeDiscountButton && this.closeDiscountButton.contains(e.target)) {
          e.stopPropagation();
          this.hideDiscountButtonPermanently();
        } else {
          // Show popup again
          this.showPopup();
          // Hide discount button
          this.hideDiscountButton();
        }
      });
    }
  }

  showPopup() {
    if (this.popup) {
      this.popup.classList.remove("hidden");
      this.popup.classList.add("wt-popup-fade-in");
    }
    
    // Show overlay
    if (this.overlay) {
      this.overlay.classList.add('show');
    }
    
    // Hide discount button when popup is shown
    this.hideDiscountButton();
    
    // Prevent body scrolling
    document.body.classList.add('popup-open');
  }

  closePopup() {
    if (this.popup) {
      this.popup.classList.add("hidden");
    }
    
    // Hide overlay
    if (this.overlay) {
      this.overlay.classList.remove('show');
    }
    
    // Show discount button when popup is closed (if not permanently hidden)
    if (!this.discountCookie) {
      this.showDiscountButton();
    }
    
    // Restore body scrolling
    document.body.classList.remove('popup-open');
  }

  showDiscountButton() {
    if (this.discountButton && !this.discountCookie) {
      this.discountButton.classList.remove('hidden');
      this.discountButton.style.display = 'flex';
    }
  }

  hideDiscountButton() {
    if (this.discountButton) {
      this.discountButton.classList.add('hidden');
      this.discountButton.style.display = 'none';
    }
  }

  hideDiscountButtonPermanently() {
    if (this.discountButton) {
      this.discountButton.classList.add('hidden');
      this.discountButton.style.display = 'none';
      
      // Set cookie to keep discount button hidden
      this.setCookie("hideDiscountButton", "true", 7);
      // Also set cookie to hide popup since user closed the discount button
      this.setCookie("hideNotificationPopup", "true", 7);
      this.discountCookie = true;
    }
  }

  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    const sameSite = 'SameSite=Lax';
    document.cookie = `${name}=${value};${expires};path=/;${sameSite}`;
  }
}

customElements.define("notification-popup", NotificationPopup);